import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconStrava$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconStrava extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '6890531e5e8335265b0711a293cadad3793c158a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f63e6b883347e8626a058926f44ed68ffa72b1ac', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9d0fe3da3e96135b978d69416575c6f65735ba00', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m12.449 12.445-2.243-4.427-2.238 4.428H4.672l5.534-10.934 5.541 10.933zm-.002 0 1.652 3.255 1.647-3.254h2.426l-4.073 8.042-4.075-8.042z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-strava", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-strava"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-strava":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconStrava$1);
            }
            break;
    } });
}

const CosmosIconStrava = CosmosIconStrava$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconStrava, defineCustomElement };
